import React, { useEffect, useState } from 'react';
import { Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { PreviousYearRecord } from 'Services/sat/types';
import useTranslation from 'Hooks/useTranslation';

const RecordRotator = ({ records }: { records: PreviousYearRecord[] }): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % records.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [records.length]);

  const currentItem = records[currentIndex];

  return (
    <Text type="paragraphs" size="S_L_S" color="grey">
      {t('PreviousYears.calculating.title', { year: currentItem?.taxYear })}
    </Text>
  );
};

export default RecordRotator;
